
import { Options, Vue } from "vue-class-component";
import { useStore }     from "vuex";
import { key }          from "@/store";

import { library }                                                  from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon }                                          from "@fortawesome/vue-fontawesome";
import { faStar, faTimes, faCommentDots, faSpinner, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

library.add( faStar, faTimes, faCommentDots, faSpinner, faCheckCircle );

@Options( {
  components : { FontAwesomeIcon }
} )
export default class AvisModal extends Vue
{
  store   = useStore( key );
  loading = false;
  success = false;
  error   = "";

  rating_note = {
    accueil  : 3,
    service  : 3,
    proprete : 3,
    prix     : 3
  };

  // Form data model
  rating_name      = "";
  rating_mail      = "";
  rating_comment   = "";
  rating_type      = "";
  rating_recommand = "";

  // Handling for submissions
  submit()
  {
    this.loading = true;
    this.error   = "";

    let formData = new FormData();
    formData.append( "gm_id", this.store.state.gm.id );
    formData.append( "name", this.rating_name );
    formData.append( "email", this.rating_mail );
    formData.append( "comment", this.rating_comment );
    formData.append( "type", this.rating_type );
    formData.append( "note_accueil", this.rating_note.accueil.toString() );
    formData.append( "note_service", this.rating_note.service.toString() );
    formData.append( "note_proprete", this.rating_note.proprete.toString() );
    formData.append( "note_prix", this.rating_note.prix.toString() );
    formData.append( "recommand", this.rating_recommand );

    let request = fetch( this.store.state.api + "avis", {
      method  : "POST",
      cache   : "no-cache",
      body    : formData
    } );

    request.then( ( res ) => { return res.json(); } ).then( this.ajaxSuccess );
    request.catch( this.ajaxError );
  }

  ajaxSuccess( response : any )
  {
    if( response.success ?? response.data?.success )
    {
      this.success = true;
      this.loading = false;
    } else
    {
      this.ajaxError( response );
    }
  }

  ajaxError( response : any )
  {
    this.success = false;
    this.loading = false;
    this.error   = response.error ?? response.data?.error ?? response.errors?.error ?? "Une erreur est survenue";
  }
}
